import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { CreateFormLayout } from 'components/create-form/CreateFormLayout';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import { FORM, LAYOUT_ITEM } from 'constants/FormConstants';
import { TextFieldLayoutItem, SelectLayoutItem, ItemList } from 'models/InputLayoutItem';
import { DATA_LAYERS, DATA_LAYER_PAGE } from 'constants/DataLayers';
import TagManager from 'react-gtm-module';
import { useFormField } from 'hooks/useFormField';
import { useStorage } from 'hooks/useStorage';

const calculateDownPaymentPercent = (vehicleValue: number, vehicleYear: number): ItemList[] => {
	let percent;
	if (vehicleYear <= 2019) {
		percent = [30, 40, 50, 60];
	} else {
		percent = [20, 30, 40, 50, 60];
	}
	let options: ItemList[];
	options = percent.map((value) => {
		const downPayment = Math.round((value * vehicleValue) / 100);
		return {
			label: `${value}% - $ ${new Intl.NumberFormat('es-CL').format(downPayment)}`,
			value: downPayment.toString(),
		};
	});

	return options;
};

export const LoanVehicleInfoForm = () => {
	const [resetField, setResetField] = useState('');
	const { getItemFromStorage } = useStorage();

	const { fields, setFields, setEnableStateInFields } = useFormField([
		{
			label: 'Valor del vehículo ',
			defaultValue: getItemFromStorage('queryParams', 'vehicleValue'),
			name: FORM.VEHICLE_VALUE,
			type: LAYOUT_ITEM.TYPE.INPUT,
			prefix: '$',
			mask: 'money',
			placeholder: ' Ej: 9.000.000',
			validation: yup
				.number()
				.required('Campo Requerido')
				.typeError('Campo Requerido')
				.min(3000000, 'Ingrese un valor superior a 3.000.000'),
		} as TextFieldLayoutItem,
		{
			defaultValue: getItemFromStorage('queryParams', 'vehicleYear'),
			label: 'Año del vehículo',
			name: FORM.VEHICLE_YEAR,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: [
				{
					label: '2022',
					value: '2022',
				},
				{
					label: '2021',
					value: '2021',
				},
				{
					label: '2020',
					value: '2020',
				},
				{
					label: '2019',
					value: '2019',
				},
				{
					label: '2018',
					value: '2018',
				},
				{
					label: '2017',
					value: '2017',
				},
				{
					label: '2016',
					value: '2016',
				},
				{
					label: '2015',
					value: '2015',
				},
				{
					label: '2014',
					value: '2014',
				},
			],
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
		{
			defaultValue: '',
			label: 'Nº de cuotas',
			name: FORM.LOAN_INSTALLMENT_NUMBER,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: [
				{
					label: '24',
					value: '24',
				},
				{
					label: '36',
					value: '36',
				},
				{
					label: '48',
					value: '48',
				},
			],
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
		{
			defaultValue: '',
			label: '% de pie',
			name: FORM.DOWN_PAYMENT,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: [],
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
	]);

	const setDownPayment = (vehicleValue: number, vehicleYear: number) => {
		let newFields = fields;
		newFields[3].options =
			vehicleValue >= 5000000 ? calculateDownPaymentPercent(vehicleValue, vehicleYear) : [];
		setFields(newFields);
		setResetField(FORM.DOWN_PAYMENT);
	};

	useEffect(
		() => {
			TagManager.dataLayer({
				dataLayer: DATA_LAYERS.get(DATA_LAYER_PAGE.PAGE_LOAN_NORMAL_INFO_VEHICULO),
			});
		},
		//eslint-disable-next-line
		[]
	);
	useEffect(
		() => {
			setEnableStateInFields([FORM.VEHICLE_VALUE, FORM.VEHICLE_YEAR], true);
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div>
			<MultiFormCardHeader
				title="Información del vehículo"
				body="Ingresa los datos del vehículo que quieres comprar."
			/>
			<CreateFormLayout
				key={fields.length}
				fields={fields}
				resetField={resetField}
				watchField={[FORM.VEHICLE_VALUE, FORM.VEHICLE_YEAR]}
				customEvent={(values) => {
					if (values.vehicleValue && values.vehicleYear) {
						setDownPayment(parseInt(values.vehicleValue), parseInt(values.vehicleYear));
					}
				}}
			/>
		</div>
	);
};
